// removed by extract-text-webpack-plugin
module.exports = {"anim":"anim__2-vSK"};


//////////////////
// WEBPACK FOOTER
// ./components/animsequence/style.less
// module id = 4n5Q
// module chunks = 6